import classNames from 'classnames';
import type { CSSProperties } from 'react';
import type { EmpyrealCrystalSize, EmpyrealCrystalType } from '@sorrem/shared';
import { CRYSTAL_TYPE_COLORS } from '@sorrem-client/ui/shared/crystal-type-colors';
import styles from './CrystalIcon.module.scss';

interface CrystalIconProps {
    crystalType: EmpyrealCrystalType;
    size: EmpyrealCrystalSize;
    /** Draws the crystal faint and translucent, e.g. one still coalescing. */
    ghost?: boolean;
    /** Dims and desaturates the crystal, e.g. one that can't be made right now. */
    dimmed?: boolean;
    className?: string;
}

/**
 * An Empyreal Crystal tinted by type, with a silhouette per size (a thin
 * shard, a broken chunk, a whole crystal). Fills its parent's box.
 *
 * TODO: swap the CSS shapes for the grayscale crystal art (one image per
 * size, tinted with --crystal-color) once it is generated; see
 * game-content/source-assets/ui/crystal-crafting/prompts.md.
 */
export function CrystalIcon({ crystalType, size, ghost = false, dimmed = false, className }: CrystalIconProps): JSX.Element {
    const style = { '--crystal-color': CRYSTAL_TYPE_COLORS[crystalType] } as CSSProperties;
    return (
        <span
            className={classNames(styles.crystalIcon, styles[size], ghost && styles.ghost, dimmed && styles.dimmed, className)}
            style={style}
            aria-hidden='true'
        >
            <span className={styles.shape} />
        </span>
    );
}
